"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var ramda_1 = require("ramda");
var Typename_1 = require("../../types/enums/Typename");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
var playbackMetaState = reselect_1.createSelector(moduleState, function (state) { return state.playbackMetaByMediaAssetId; });
exports.playbackMetaIsLoading = reselect_1.createSelector(playbackMetaState, function (state) { return state.isLoading; });
exports.playbackMetaError = reselect_1.createSelector(playbackMetaState, function (state) { return state.error; });
var playbackConcurrencyState = reselect_1.createSelector(moduleState, function (state) { return state.playbackConcurrencyById; });
exports.playbackConcurrencyIsLoading = reselect_1.createSelector(playbackConcurrencyState, function (state) { return state.isLoading; });
var offlinePlaybackState = reselect_1.createSelector(moduleState, function (state) { return state.offlinePlaybackMetaByMediaAssetId; });
exports.offlinePlaybackIsLoading = reselect_1.createSelector(offlinePlaybackState, function (state) { return state.isLoading; });
exports.offlinePlaybackError = reselect_1.createSelector(offlinePlaybackState, function (state) { return state.error; });
exports.isConcurrentPlaybackError = reselect_1.createSelector(playbackMetaState, function (state) { return function (mediaAssetId) {
    if (state.data[mediaAssetId]) {
        // eslint-disable-next-line no-underscore-dangle
        return state.data[mediaAssetId].__typename === Typename_1.Typename.ConcurrencyError;
    }
    return false;
}; });
exports.isTvodPurchaseMissingError = reselect_1.createSelector(playbackMetaState, function (state) { return function (mediaAssetId) {
    if (state.data[mediaAssetId]) {
        // eslint-disable-next-line no-underscore-dangle
        return state.data[mediaAssetId].__typename === Typename_1.Typename.TvodPurchaseMissing;
    }
    return false;
}; });
exports.isTvodPurchaseExpiredError = reselect_1.createSelector(playbackMetaState, function (state) { return function (mediaAssetId) {
    if (state.data[mediaAssetId]) {
        // eslint-disable-next-line no-underscore-dangle
        return state.data[mediaAssetId].__typename === Typename_1.Typename.TvodPurchaseExpired;
    }
    return false;
}; });
exports.getSubscriptions = reselect_1.createSelector(playbackMetaState, function (state) { return function (mediaAssetId) {
    var asset = state.data[mediaAssetId];
    if ((asset === null || asset === void 0 ? void 0 : asset.__typename) === Typename_1.Typename.SubscriptionNeeded) {
        return asset.subscriptions;
    }
    return null;
}; });
exports.getPlaybackMeta = reselect_1.createSelector(playbackMetaState, exports.getSubscriptions, exports.isConcurrentPlaybackError, function (state, getSubscriptionsState, isConcurrentError) { return function (mediaAssetId) {
    var subscriptions = getSubscriptionsState(mediaAssetId);
    if (!isConcurrentError(mediaAssetId) && (ramda_1.isNil(subscriptions) || ramda_1.isEmpty(subscriptions))) {
        return state.data[mediaAssetId];
    }
    return undefined;
}; });
exports.getOfflineSubscriptions = reselect_1.createSelector(offlinePlaybackState, function (state) { return function (mediaAssetId) {
    var asset = state.data[mediaAssetId];
    if ((asset === null || asset === void 0 ? void 0 : asset.__typename) === Typename_1.Typename.SubscriptionNeeded) {
        return asset.subscriptions;
    }
    return null;
}; });
exports.getOfflinePlaybackMeta = reselect_1.createSelector(offlinePlaybackState, exports.getOfflineSubscriptions, function (state, getOfflineSubscriptionsState) { return function (mediaAssetId) {
    var subscriptions = getOfflineSubscriptionsState(mediaAssetId);
    if (ramda_1.isNil(subscriptions) || ramda_1.isEmpty(subscriptions)) {
        return state.data[mediaAssetId];
    }
    return undefined;
}; });
var textTracksByMediaAssetId = reselect_1.createSelector(moduleState, function (state) { return state.textTracksByMediaAssetId; });
exports.getTextTracksByMediaAssetId = reselect_1.createSelector(textTracksByMediaAssetId, function (state) { return function (mediaAssetId) {
    return state === null || state === void 0 ? void 0 : state[mediaAssetId];
}; });
exports.hasTextTracksByMediaAssetId = reselect_1.createSelector(exports.getTextTracksByMediaAssetId, function (state) { return function (mediaAssetId) {
    var _a;
    return !!((_a = state(mediaAssetId)) === null || _a === void 0 ? void 0 : _a.length);
}; });
exports.getAudioTracks = reselect_1.createSelector(moduleState, function (state) { return function () { return state.audioTracks; }; });
//# sourceMappingURL=selectors.js.map